import { useQuery } from "@tanstack/react-query";
import { ApiGetRiskList } from "@/api";
import type { GetRiskListResponse } from "@/api/types";

/**
 * 获取 AI 交易风险偏好列表（/game/cex/GetRiskList）
 */
export function useGetRiskList() {
  return useQuery({
    queryKey: ["riskList"],
    queryFn: async (): Promise<GetRiskListResponse> => {
      const res = await ApiGetRiskList();
      console.log("useGetRiskList", res.data);
      return res.data;
    },
  });
}
